import { render, staticRenderFns } from "./ReferralsShowDetails.vue?vue&type=template&id=218e8d84"
import script from "./ReferralsShowDetails.vue?vue&type=script&lang=js"
export * from "./ReferralsShowDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports